/**
 *  @class
 *  @function FeaturedBlogExternal
 */

 class FeaturedBlogExternal {
    constructor() {
      this.container = document.querySelector('.blog-posts');
      this.setupEventListeners();
    }

     truncateWords(str, numWords) {
      const words = str.split(' ');
      const truncated = words.slice(0, numWords).join(' ');
      return truncated + (words.length > numWords ? '...' : '');
    }

    truncateWordsWithMarkup(html, maxLength) {
      let plainText = html.replace(/<[^>]*>/g, '');
      
      if (plainText.length > maxLength) {
        plainText = plainText.substr(0, maxLength);
        plainText = plainText.substr(0, Math.min(plainText.length, plainText.lastIndexOf(" ")));
        plainText += '...';
      }
      
      let temp = document.createElement('div');
      temp.innerHTML = html;
      
      let nodes = temp.querySelectorAll('*');
      for (let i = 0; i < nodes.length; i++) {
        if (nodes[i].childNodes.length === 0) {
          continue;
        }
        for (let j = 0; j < nodes[i].childNodes.length; j++) {
          let childNode = nodes[i].childNodes[j];
          if (childNode.nodeType === Node.TEXT_NODE) {
            childNode.textContent = childNode.textContent.replace(plainText, plainText + " ");
          }
        }
      }
      
      return temp.innerHTML;
    }

    setupEventListeners() {
        this.row = this.container.querySelector('.row');
        this.rowClass = this.row.getAttribute('data-class-external');

        this.blog_source =  this.container.getAttribute('data-blog-source');
        this.blog_json_feed =  this.container.getAttribute('data-blog-feed');
        this.blog_max =  this.container.getAttribute('data-blog-limit');

        this.show_date =  this.container.getAttribute('data-blog-source-show_date');
        this.show_excerpt =  this.container.getAttribute('data-blog-source-show_excerpt');
        this.show_image =  this.container.getAttribute('data-blog-source-show_image');
        this.use_shapes =  this.container.getAttribute('data-blog-source-use_shapes');
        this.show_category =  this.container.getAttribute('data-blog-source-show_category');
        this.image_ratio =  this.container.getAttribute('data-blog-source-image_ratio');

        this.read_more = this.container.getAttribute('data-blog-source-read_more');
        

        if(this.blog_source  == 'external'){
          this.loadExternalSource();
        }
      }

      loadExternalSource(){
        var request_url = this.blog_json_feed;

        const request = new Request(request_url, {
          method: 'GET',
          mode: 'cors', // no-cors, *cors, same-origin
          credentials: 'same-origin', // include, *same-origin, omit
          headers: {
            'Content-Type': 'application/json',
            //'API-Key': 'secret'
          },
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        });
    
        fetch(request)
        .then(response => {
          const contentType = response.headers.get('content-type');
         
          if (!contentType || !contentType.includes('application/json')) {
            throw new TypeError("Error, JSON NOT RETURNED!");
          }
          return response.json();
        })
        .then(data => {
          var blog_articles = data.items.slice(0,this.blog_max);
          var blog_base_url = data.home_page_url;
      
          var blog_articlesBlock = this.row;
          const months = ["JAN", "FEB", "MAR","APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    
          blog_articles.forEach((item,index) => {
            let local_data = item;

            let local_index = index % 9  + 1;
            let local_ratio = 1;
            let local_image_sizes = '320x0,640x0';

            switch(this.image_ratio){
                case 'adapt' : 
                    local_image_sizes = '320x0,640x0';
                break;
                case 'square' :
                    local_image_sizes = '320x320,640x640';
                    local_ratio = 1;
                break;
                case 'landscape' :
                    local_image_sizes = '320x200,640x400';
                    local_ratio = 1.6;
                break;
                case 'portrait' :
                    local_image_sizes = '320x400,640x800';
                    local_ratio = 0.8;
                break;
            }


            let local_img = local_data.image_m.replace(/(width=")\d+("\W+height=")\d+/, '$1$2');
                local_img = local_img.replace('wp-post-image','wp-post-image lazyload');
                local_img = local_img.replace('<img','<img data-sizes="auto"');

            let local_date = Date.parse(local_data.date_published);
            let local_date_conv = new Date(local_date);
            let local_date_MMYY = `${months[local_date_conv.getMonth()]} ${local_date_conv.getFullYear()}`;

            let local_ratio_percent  = 1 / local_ratio * 100;

            let local_image_block_render = '';
            if(this.show_image == 'true' ){
                local_image_block_render = `
                <figure class="featured-image aspect-ratio" style="--ratio-percent: ${local_ratio_percent}%;">
                        <a href="${local_data.url}" title="${local_data.title}">
                            ${local_img}
                        </a>
                </figure>
                `;
            }

            let local_category_block_render = '';
            if(this.show_category == 'true' ){
                local_data.catname = local_data.categories.map(function(cat) {
                    return ` <a href="${blog_base_url}/category/${cat['slug']}" rel="category tag">${cat['name']}</a>`;
                }).toString();
    
                local_category_block_render = `
                <aside class="post-category text-size-smaller">
                    ${local_data.catname}
                </aside>
                `;
            }

            let local_date_block_render = '';
            if(this.show_date == 'true' ){
                local_date_block_render = `
                <aside class="post-meta">
                    ${local_date_MMYY}
                </aside>
                `;
            }

            let local_excerpt_block_render = '';
            if(this.show_excerpt == 'true' ){
              const truncatedText = this.truncateWords(local_data.summary, 30);
              
                local_excerpt_block_render = `
                <div class="post-excerpt">
                    <p>${truncatedText}</p>
                </div>
                `;
            }
            
            let local_use_shapes_render = '';
            if(this.use_shapes == 'true' ){
                local_use_shapes_render = `blog-post-shape-${local_index}`;
            }
            
            var templateBlock = `<div class="${this.rowClass}">
                <div class="blog-post ${local_use_shapes_render}">
                    ${local_image_block_render}
                    ${local_category_block_render}
                    ${local_date_block_render}
                    <h5 class="h6"><a href="${local_data.url}" title="${local_data.title}" role="link" aria-disabled="true">${local_data.title}</a></h5>
                    ${local_excerpt_block_render}
                    <a role="link" aria-disabled="true" class="read-more">${this.read_more}</a>
                </div>
			</div>
            `;

            blog_articlesBlock.insertAdjacentHTML( 'beforeend', templateBlock );

          });
        }).catch((error) => {
          console.error('Error:', error);
        });
      }

      
}

window.addEventListener('load', () => {
    if (typeof FeaturedBlogExternal !== 'undefined') {
      new FeaturedBlogExternal();
    }
});

